import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainLayout from "../layout/layout-main.js";
import SysLayout from "../layout/layout-sys.js";
import SysMainLayout from "../layout/layout-sys-main.js";

import MainContent from './ve/main-content.js';
import Competition from './ve/competition.js';
import MatchResult from './ve/match-result.js';
import TrmntMaker from './ve/trmnt-maker.js';
import Faq from './ve/faq.js';

import SysContent from './sys/sys-content.js';
/* sys bs ui */
import PlayerMng from './sys/bs/player-mng.js';
import DivisionMng from './sys/bs/division-mng.js';
import SupportersMng from './sys/bs/supporters-mng.js';
import WeightClassMng from './sys/bs/weightClass-mng.js';
/* sys cm ui */
import CompetitionMng from './sys/cm/competition-mng.js';
import MatchmakingMng from './sys/cm/matchmaking-mng.js';
import CompetitionFormMng from './sys/cm/competitionForm-mng.js';
import CompetitionApplyMng from './sys/cm/competitionApply-mng.js';
import MatchResultMng from './sys/cm/matchResult-mng.js';
import MatchDtlMng from './sys/cm/matchdtl-mng.js';
import MatchTrmntMng from './sys/cm/matchtrmnt-mng.js';
/* adm cm ui */
import CmptnAllowMng from './adm/cm/cmptnAllow-mng.js';

/* sample */
import SampleLayout from "../layout/layout-sample.js";
import Product from '@pages/sample/product.js';

// 404 Not Found
import NotFound from '@pages/notFound.js';
import Login from './login.js';

export default function Main() {
	// console.log('start app = ' + process.env.REACT_APP_API_URL);
	
    return (
        <>	
            <BrowserRouter>
				<Routes>
					{/* main layout */}
					<Route path="/login" element={<MainLayout> <Login /> </MainLayout>}></Route>
					<Route path="/" element={<MainLayout> <MainContent /> </MainLayout>}></Route>
					<Route path="/ve" element={<MainLayout> <MainContent /> </MainLayout>}></Route>
					<Route path="/ve/competition" element={<MainLayout> <Competition /> </MainLayout>}></Route>
					<Route path="/ve/match-result" element={<MainLayout> <MatchResult /> </MainLayout>}></Route>
					<Route path="/ve/trmnt-maker" element={<MainLayout> <TrmntMaker /> </MainLayout>}></Route>
					<Route path="/ve/faq" element={<MainLayout> <Faq /> </MainLayout>}></Route>

					{/* sys layout */}
					<Route path="/sys/main" element={<SysMainLayout> <SysContent /> </SysMainLayout>}></Route>
					<Route path="/sys/bs/player-mng" element={<SysLayout> <PlayerMng /> </SysLayout>}></Route>
					<Route path="/sys/bs/division-mng" element={<SysLayout> <DivisionMng /> </SysLayout>}></Route>
					<Route path="/sys/bs/supporters-mng" element={<SysLayout> <SupportersMng /> </SysLayout>}></Route>
					<Route path="/sys/bs/weightClass-mng" element={<SysLayout> <WeightClassMng /> </SysLayout>}></Route>
					
					<Route path="/sys/cm/competition-mng" element={<SysLayout> <CompetitionMng /> </SysLayout>}></Route>
					<Route path="/sys/cm/matchmaking-mng" element={<SysLayout> <MatchmakingMng /> </SysLayout>}></Route>
					<Route path="/sys/cm/competitionForm-mng" element={<SysLayout> <CompetitionFormMng /> </SysLayout>}></Route>
					<Route path="/sys/cm/competitionApply-mng" element={<SysLayout> <CompetitionApplyMng /> </SysLayout>}></Route>
					<Route path="/sys/cm/matchResult-mng" element={<SysLayout> <MatchResultMng /> </SysLayout>}></Route>
					<Route path="/sys/cm/matchdtl-mng" element={<SysLayout> <MatchDtlMng /> </SysLayout>}></Route>
					<Route path="/sys/cm/matchtrmnt-mng" element={<SysLayout> <MatchTrmntMng /> </SysLayout>}></Route>

					{/* adm layout */}
					<Route path="/adm/cm/cmptnAllow-mng" element={<SysLayout> <CmptnAllowMng /> </SysLayout>}></Route>

                    {/* sample layout */}
					<Route path="/sample" element={<SampleLayout />}></Route>
                    <Route path="/sample/product/:productId" element={<SampleLayout> <Product /> </SampleLayout>}></Route>

					{/* not found page */}
					<Route path="*" element={<NotFound />}></Route>
				</Routes>
			</BrowserRouter>
        </>
    );
}
